import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { IForm } from 'core-components/classes/models/IForm'
import { guid } from 'core/classes/helpers/GuidHelper'
import { CrudStore } from 'core/types/crudStore'

interface IGetInitialContactData {
  partnerId: string
}

export async function getInitialContactData({ partnerId }: IGetInitialContactData) {
  const crud = CrudStore.get(CrudStoreItem.PartnerAllData, `partner-contacts-${partnerId}`)
  const initialData: DataModel | IForm = new DataModel({})

  const partner = await crud.getById({ id: partnerId, keyField: 'PartnerID' })
  initialData.set('PartnerID', partnerId)
  initialData.set('ParentPartnerID', partner ? partner.ParentPartnerID : partnerId)
  initialData.set('ContactID', `new-${guid()}`)
  initialData.set('Country', partner ? partner.CountryExt || partner.Country : '')
  initialData.set('Market', partner?.Market || null)

  return { initialData }
}
